import { NgModule } from '@angular/core';

import { FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from '../../../../shared';

import { UsuarioAvatarUploadComponent } from './usuario-avatar-upload.component';

@NgModule({
    imports: [
        SharedModule,
        FileUploadModule
    ],
    declarations: [
        UsuarioAvatarUploadComponent
    ],
    exports: [
        UsuarioAvatarUploadComponent
    ]
})
export class UsuarioAvatarUploadModule { }
